import Vue from 'vue'
import Vuex from 'vuex'
import SDKComponents from './modules/sdkComponents'
import getters from './getters'

Vue.use(Vuex)

// 实例化 store
const store = new Vuex.Store({
  // strict: true,
  modules: {
    SDKComponents
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js